import React from "react";
import { ShopCenter } from "@/components/ShopCenter";
const Temu = () => <ShopCenter brand="temu" />;
export default Temu;
